import React, { Component } from "react";

import { faTrash } from "@fortawesome/free-solid-svg-icons/faTrash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import DupontIconButton from "../DupontIconButton";

class DeleteRenderer extends Component {
  constructor(props) {
    super(props);
    this.invokeParentMethod = this.invokeParentMethod.bind(this);
  }
  invokeParentMethod() {
    this.props.context.deleteHandler(this.props.node.data);
  }
  render() {
    const { node } = this.props;
    const { is_owner: isOwner, type } = node?.data || {};
    const isDisabled =
      typeof isOwner !== "undefined" ? !isOwner : type === "Owner";
    return (
      <div style={{ margin: 2 }}>
        <DupontIconButton
          onClick={this.invokeParentMethod}
          customClass={{ margin: "2px" }}
          disabled={isDisabled}
        >
          <FontAwesomeIcon icon={faTrash} color="white" />
        </DupontIconButton>
      </div>
    );
  }
}

export default DeleteRenderer;
